import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';

const teamNanoteh1 = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemTitle: 'Александр Букуров',
            crewItemSubtitle: 'владелец продукта',
        },
        {
            crewItemTitle: 'Сергей Аверкиев',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemTitle: 'Константин Кулишов',
            crewItemSubtitle: 'старший DevOps-инженер',
        },
        {
            crewItemTitle: 'Виктория Кривко',
            crewItemSubtitle: 'SEO-специалист',
        },

        {
            crewItemTitle: 'Иван Поддубный',
            crewItemSubtitle: 'технический директор',
        },
        {
            crewItemTitle: 'Петр Кленкин',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemTitle: 'Роман Ципленков',
            crewItemSubtitle: 'DevOps-инженер',
        },
        {
            crewItemTitle: 'Александр Сидоров',
            crewItemSubtitle: 'старший аналитик',
        },

        {
            crewItemTitle: 'Алексей Кореньков',
            crewItemSubtitle: 'руководитель группы backend-разработки',
        },
        {
            crewItemTitle: 'Сергей Буланов',
            crewItemSubtitle: 'младший backend-разработчик',
        },
        {
            crewItemTitle: 'Вадим Шапошников',
            crewItemSubtitle: 'руководитель SEO-команды',
        },
        {
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'старший веб-дизайнер',
        },

        {
            crewItemTitle: 'Александр Забанов',
            crewItemSubtitle: 'старший backend-разработчик',
        },
        {
            crewItemTitle: 'Павел Воробьев',
            crewItemSubtitle: 'frontend-разработчик',
        },
        {
            crewItemTitle: 'Мария Лапиева',
            crewItemSubtitle: 'старший frontend-разработчик',
        },
        {
            crewItemTitle: 'Александр Рахманин',
            crewItemSubtitle: 'старший SEO-специалист',
        },
        {
            crewItemTitle: 'Алина Климец',
            crewItemSubtitle: 'контент-менеджер',
        },
    ],
};

const Team = () => {
    return (
        <FullWrapper caseName="topdf-team">
            <CommonTitle>Команда</CommonTitle>
            <CrewContainer container={teamNanoteh1} />
        </FullWrapper>
    );
};

export default Team;
